<template>
  <button
    type="button"
   
    aria-label="Clear"
    class="flex items-center gap-2 justify-center cursor-pointer hover:bg-gray-100 rounded-full size-6"
  >
    <TIcon
      :icon="['fal', 'xmark']"
      size="sm"
    />
  </button>
</template>
